import Vue from 'vue';
import { gsap } from 'gsap/all';
import Draggable from "gsap/Draggable";
import imagesLoaded from 'imagesloaded';
import { InertiaPlugin } from '../gsap-bonus/InertiaPlugin';

gsap.registerPlugin(Draggable, InertiaPlugin);

Vue.component('cool-slider-component', {
    data() {
        return {

        };
    },

    mounted() {
        imagesLoaded(this.$el, () => {
            this.init();
            this.listen();
        });
    },

    methods: {
        init(time = 0) {
            const viewport = document.querySelector(".block-slider");
            const wrapper = document.querySelector(".block-slider__container");
            const boxes = document.querySelector(".block-slider__inner");
            const proxy = document.createElement("div");
            const boxElements = [...document.querySelectorAll('.block-slider__slide')];
    
            // const boxWidth = gsap.utils.random([350, 250, 150]);
            // const boxHeight = 1228;
            const viewWidth = '';
            let wrapWidth = 0; // numBoxes * boxWidth;
    
            const max = Math.max(...boxElements.map(function (o) { return o.getBoundingClientRect().width; }))
            const boxHeight = Math.max(...boxElements.map(function (o) { return o.getBoundingClientRect().height; }))
    
            for (let index = 0; index < boxElements.length; index++) {
                const element = boxElements[index];
                const bounds = element.getBoundingClientRect();
                const boxWidth = bounds.width;
    
                gsap.set(element, { x: wrapWidth + max });
                wrapWidth += boxWidth;
            }
    
            const wrapVal = gsap.utils.wrap(0, wrapWidth);
            gsap.set([viewport], { height: boxHeight + 70 }); // adding some extra space for the progressbar
            gsap.set([boxes], { height: boxHeight });
            gsap.set([wrapper], { height: boxHeight, xPercent: -50 });
            gsap.set(boxes, { left: -max });
    
            this.animation = gsap.to(".block-slider__slide", {
                duration: 1,
                x: `+=${wrapWidth}`,
                ease: "none",
                paused: true,
                modifiers: {
                    x: function (x, target) {
                        x = parseInt(x) % wrapWidth;
                        return `${x}px`;
                    }
                }
            });

            this.animation.seek(time);
            const that = this;
            const progressBar = document.querySelector('.block-slider__progressbar').getBoundingClientRect();
            function updateProgress() {
                // console.log(that.animation)
                that.animation.progress(wrapVal(this.x) / wrapWidth);
                const progress = Math.round(((that.animation.progress()) + Number.EPSILON));
                gsap.to(".block-slider__progressbar-line", {
                    x: progressBar.width * progress
                });
            }

            if (!this.draggable) {
                this.draggable = Draggable.create(proxy, {
                    type: "x",
                    trigger: ".block-slider__container",
                    inertia: true,
                    onDrag: updateProgress,
                    onThrowUpdate: updateProgress,
                    onPress: () => {
                        gsap.to('.block-slider__image-holder', {
                            duration: 0.6,
                            ease: 'expo.easeOut',
                            scale: 0.9
                        });
    
                        gsap.to('.block-slider__image', {
                            duration: 0.6,
                            ease: 'expo.easeOut',
                            scale: 1.1
                        });
    
                        gsap.to('.block-slider__slide-info', {
                            duration: 0.6,
                            ease: 'expo.easeOut',
                            autoAlpha: 0
                        });
                    },
                    onRelease: () => {
                        gsap.to('.block-slider__image-holder', {
                            duration: 0.6,
                            ease: 'expo.easeOut',
                            scale: 1
                        });
    
                        gsap.to('.block-slider__image', {
                            duration: 0.6,
                            ease: 'expo.easeOut',
                            scale: 1
                        });
    
                        gsap.to('.block-slider__slide-info', {
                            duration: 0.6,
                            ease: 'expo.easeOut',
                            autoAlpha: 1
                        });
                    },
                    snap: {
                        x: (x) => {
                            return x;
                        }
                    }
                });
            }
        },

        resize() {
            // viewWidth = viewport.offsetWidth;
            const time = this.animation.time();
            this.animation.kill();
            this.init(time);
            // this.animation.render(this.animation.time(), false, true);
        },

        kill() {
            this.animation.kill();
        },

        listen(){
            window.addEventListener('resize', this.resize);
        }
    },
});